// extracted by mini-css-extract-plugin
export default {"content":"styles_content__VQgE9","save":"styles_save__YsYbk","contentwrapper":"styles_contentwrapper__1u5rB","info":"styles_info__oC1nu","cards":"styles_cards__20+Ax"};